const KYCDocumentType= {
    IDENTITY_PROOF: "Identity Proof",
    ARTICLES_OF_ASSOCIATION: "Articles of Association",
    REGISTRATION_PROOF: "Registration Proof",
    UBO_DECLARATION: "UBO Declaration"
};

export default KYCDocumentType;
